import IdpParticipation from './model';
import create from './create';

IdpParticipation.create = create;

export default IdpParticipation;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/IdpParticipation/index.js